<template>
  <div class="bijiao">
    <div class="title">
      <strong>{{ $t("compare.comparison") }}</strong>
    </div>
    <!-- <div class="subTitle">
      <el-radio v-model="radio" label="1">显示所有特征</el-radio>
      <el-radio v-model="radio" label="2">显示所有特征</el-radio>
    </div> -->
    <br />
    <br />
    <div
      class="box"
      :style="
        `width:${(store.bijiaoProduct.length + 1) *
          300}px;height:${title.length * 70}px`
      "
    >
      <div class="title">{{ $t("compare.describe") }}</div>
      <div class="item item1">
        <ul>
          <li v-for="it in title" :key="it">{{ it }}</li>
        </ul>
      </div>
      <div class="item" v-for="item in store.bijiaoProduct" :key="item.id">
        <div class="tt">
          <div class="img" @click="toProduct(item)">
            <img v-if="item.pictureList" :src="item.pictureList[0]" alt="" />
          </div>
          <div class="t1" @click="toProduct(item)">
            <strong>{{ item.title }}</strong>
          </div>
          <div class="t2" @click="toProduct(item)">{{ item.subtitle }}</div>
          <div class="t3" @click="toProduct(item)">
            <strong>{{ item.price }}</strong>
          </div>

          <div class="close">
            <i class="el-icon-close" @click="actionBiJiao(item)"></i>
          </div>
        </div>
        <ul>
          <!-- <li v-for="(it,index) in item.technicalParameters" :key="index">{{it.val}}</li> -->
          <!-- <li v-for="(it,index) in title" :key="index">{{item.technicalParameters}}</li> -->
          <li v-for="(it, index) in title" :key="index">
            {{ ret(item.technicalParameters, it) }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Store from "../store";

export default {
  data() {
    return {
      store: Store.state,
      radio: "1",
      title: [],
      list: [],
    };
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });


    console.log(this.store.bijiaoProduct);
    for (let i = 0; i < this.store.bijiaoProduct.length; i++) {
      if (typeof this.store.bijiaoProduct[i].technicalParameters == "string") {
        this.store.bijiaoProduct[i].technicalParameters = this.stringToArray(
          this.store.bijiaoProduct[i].technicalParameters
        );
      }
      for (
        let j = 0;
        j < this.store.bijiaoProduct[i].technicalParameters.length;
        j++
      ) {
        if (
          this.title.indexOf(
            this.store.bijiaoProduct[i].technicalParameters[j].key
          ) == -1
        ) {
          this.title.push(
            this.store.bijiaoProduct[i].technicalParameters[j].key
          );
        }
      }
    }
  },
  methods: {
    // 处理技术参数
    stringToArray(st) {
      let arr = st.split("\n");
      let arrTwo = [];
      for (let i = 0; i < arr.length; i++) {
        arrTwo.push({
          key: arr[i].substring(0, arr[i].indexOf("|")),
          val: arr[i].substring(arr[i].indexOf("|") + 1, arr[i].length),
        });
      }
      return arrTwo;
    },
    // 选中/取消选中产品
    actionBiJiao(item) {
      console.log(item);
      Store.actionBiJiao(item);
    },
    // 跳转到产品
    toProduct(item) {
      this.$router.push({
        path: "/product",
        query: {
          productId: item.id,
        },
      });
    },
    ret(arr, item) {
      // let ind = arr.indexOf(item)
      // console.log(arr);
      let obj = { 12: "12" };
      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].key] = arr[i].val;
      }
      console.log(obj);
      if (obj[item]) {
        return obj[item];
      } else {
        return "-";
      }
    },
  },
  // beforeDestroy(){
  //   this.store.bijiaoProduct = []
  // }
};
</script>

<style lang="less" scoped>
.bijiao {
  .title {
    font-size: 1.875rem;
    text-align: center;
    line-height: 3.125rem;
    margin-top: 6.25rem;
  }
  .subTitle {
    line-height: 6.25rem;
    font-size: 1.5625rem;
    text-align: center;
  }
  .box {
    margin-top: 6.25rem;
    .title {
      width: 100%;
      height: 3.75rem;
      background-color: rgb(44, 56, 68);
      text-align: left;
      padding-left: 1.875rem;
      font-size: 1.25rem;
      border-radius: 0.625rem 0 0 0;
      color: #fff;
      line-height: 3.75rem;
      box-sizing: border-box;
    }
    white-space: nowrap;
    padding: 0 3.125rem;

    .item {
      float: left;
      width: 18.75rem;
      height: 37.5rem;
      position: relative;
      li {
        height: 3.75rem;
        border-bottom: 0.0313rem solid #333;
        border-right: 0.0313rem solid #333;
        padding: 0.3125rem;
        box-sizing: border-box;
        table-layout: fixed;
        font-size: 0.75rem;
        line-height: 0.875rem;
        overflow: hidden;
        word-break: break-all;
        white-space: pre-wrap;
        color: #555;
      }
      .tt {
        position: absolute;
        top: 0;
        left: 0;
        width: 18.625rem;
        height: 6.25rem;
        background-color: #fff;
        transform: translateY(-10.125rem);
        border-radius: 0.625rem 0.625rem 0 0;
        border: 0.0313rem solid #ccc;
        display: grid;

        grid-template-columns: 6.25rem 11.25rem;
        grid-template-rows: 3.125rem 1.25rem 1.875rem;
        .img {
          grid-row-start: span 3;
          text-align: center;
          img {
            margin-top: 0.625rem;
            width: 5rem;
            height: 5rem;
          }
        }
        .t1 {
          color: #4abcb9;
          font-size: 1.25rem;
          line-height: 3.75rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .t2 {
          font-size: 0.8125rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .t3 {
          text-align: right;
          color: #4abcb9;
          padding-right: 1.25rem;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .close {
          position: absolute;
          top: 0.3125rem;
          right: 0.3125rem;
          z-index: 999;
        }
      }
    }
    .item1 {
      li {
        border-left: 0.0313rem solid #333;
        font-size: 1.125rem;
        line-height: 3.125rem;
        text-align: right;
        background-color: rgb(224, 237, 235);
        color: #4abcb9;
        padding-right: 1.875rem;
      }
    }
  }
}
</style>
